<template>
    <div>
        <list-item>
            <template slot="icon">
                <i class="text-blue far fa-calendar-alt"></i>
            </template>
            <template slot="title">Date of Drive</template>
            <template slot="sub-title">{{ formatDate(expense.date, 'D MMM YYYY') }}</template>
        </list-item>

        <list-item>
            <template slot="icon">
                <i class="text-blue far fa-road"></i>
            </template>
            <template slot="title">Distance (km)</template>
            <template slot="sub-title">
                {{ expense.distance.join('.') }}
            </template>
        </list-item>

        <list-item>
            <template slot="icon">
                <i class="text-blue far fa-question-circle"></i>
            </template>
            <template slot="title">Reason for Drive</template>
            <template slot="sub-title">
                {{ expense.reason }}
            </template>
        </list-item>

        <list-item>
            <template slot="icon">
                <i class="text-blue far fa-route"></i>
            </template>
            <template slot="title">Route</template>
            <template slot="sub-title">
                {{ expense.route }}
            </template>
        </list-item>

    </div>
</template>

<script>
import InteractsWithDates from '@/mixins/InteractsWithDates';

export default {
    mixins: [InteractsWithDates],
    props: ['expense'],
}
</script>
